import { observer } from 'mobx-react-lite'
import { useStore } from '../../../../models'
import { events } from '../../../../models/analytics/analytics-events'
import { BaseButton } from './BaseButton'

export const ContinueWalkthroughButton = observer(() => {
  const {
    analytics: { setEvent },
    game: { clearWalkthrough, setWalkthroughType, walkthroughType },
    session: { user }
  } = useStore()

  const handleContinueWalkthrough = () => {
    clearWalkthrough()
    if (walkthroughType === 'TableTour') {
      setEvent(events.homescreen.raise_or_fold_started, { userId: user?._id.toString() })
      setWalkthroughType('RaiseOrFold')
    } else if (walkthroughType === 'RaiseOrFold') {
      setWalkthroughType('DealTheFlop')
    }
  }

  return <BaseButton text="Continue Walkthrough" onPress={handleContinueWalkthrough} numberOfLines={1} />
})
